export default __webpack_public_path__ + "static/media/ic_honduras.0fb62cc8.svg";